<style lang="less" scoped>
.homeheader-bg-box {
  width: 100%;
  height: 96px;
  background-image: url("@/assets/components/head-home-img/title-bg-head.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding: 0 20px;
  justify-content: space-between;
  //align-items: center;

  .title-txt {
    height: 44px;
    font-size: 36px;
    color: #fff;
    font-family: "Title-Family";
    letter-spacing: 15px;
    text-shadow: 2px 2px 6px #146de6;
    padding-top: 15px;
  }

  .hd-rg-item {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .go-home {
    width: 81px;
    height: 50px;
    cursor: pointer;
    background-image: url("@/assets/components/head-home-img/com-go-home-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .go-home-icon {
      background-image: url("@/assets/components/head-home-img/go-home-icon.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 35px;
      height: 35px;
    }
  }

  .set-btn {
    width: 111px;
    height: 50px;
    background-image: url("@/assets/components/head-home-img/com-set-btn-bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: pointer;
    color: #bdc4cc;

    .set-option-box {
      position: absolute;
      top: 50px;
      left: 0;
      padding: 12px 0;
      z-index: 999;

      .set-option-item {
        background-image: url("@/assets/components/head-home-img/drop-down-bg-activit.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 112px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 10px;
        font-size: 16px;
        color: #bdc4cc;
      }

      .set-option-item:hover {
        background-image: url("@/assets/components/head-home-img/drop-down-bg.png");
        color: #fff;
      }
    }
  }

  .drop-down-icon {
    width: 20px;
    height: 8px;
    background-image: url("@/assets/components/head-home-img/drop-down-icon-red.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .select-option-box {
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    .selected-item-style {
      background-image: url("@/assets/components/head-home-img/item-option.png");
      width: 168px;
      height: 50px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      cursor: pointer;
      position: relative;
      line-height: 50px;

      .drop-title-box {
        text-align: center;

        .drop-title-text {
          color: #bdc4cc;
          font-size: 20px;
          margin-right: 8px;
        }
      }

      .custdorop {
        width: 100%;
        position: absolute;
        top: 50px;
        left: 0;
        padding: 12px;
        z-index: 9999;

        .drop-down-item-box {
          background-image: url("@/assets/components/head-home-img/drop-down-bg-activit.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 137px;
          height: 38px;
          font-size: 16px;
          color: #bdc4cc;
          text-align: center;
          line-height: 38px;
          margin-bottom: 10px;
        }

        .drop-down-item-box:hover {
          background-image: url("@/assets/components/head-home-img/drop-down-bg.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          color: #fff;
        }

        .drop-down-activt {
        }
      }
    }

    .selected-item-style:hover {
      background-image: url("@/assets/components/head-home-img/activt-item-option.png");
    }

    .selected-item-style:hover .drop-down-icon {
      background-image: url("@/assets/components/head-home-img/drop-down-icon.png");
    }

    .selected-item-style:hover .drop-title-text {
      color: #fff;
    }
  }
}

.redheader-title {
  font-size: 44px;
  color: #fff;
  font-weight: 800;
  letter-spacing: 8px;
  width: 708px;
  text-align: center;
}
</style>
<template>
  <div class="homeheader-bg-box arFlex">
    <div class="title-txt">{{ userinfo.nickname }}街道<br/>综合管理数字化平台</div>
    <div class="hd-rg-item">
      <div class="go-home" @click="clicknavgethome()">
        <div class="go-home-icon"></div>
      </div>
      <div class="select-option-box arFlex">
        <div
          v-for="(item, index) in RouteList"
          :key="index"
          class="selected-item-style"
        >
          <div
            class="drop-title-box"
            @mouseenter="dropdropshow(item.menuId)"
            @mouseleave="dropdropdropshow(item.menuId)"
          >
            <span class="drop-title-text">{{ item.menuName }}</span>
            <i class="drop-down-icon"></i>
          </div>
          <div
            v-show="menuid === item.menuId"
            class="custdorop"
            @mouseenter="dropdropshow(item.menuId)"
            @mouseleave="dropdropdropshow(item.menuId)"
          >
            <div
              v-for="(items, indexs) in item.children"
              :key="indexs"
              class="drop-down-item-box"
              @click="
                navtopushfun(item.menuId, items.url, items.type, items.status)
              "
            >
              {{ items.name }}
            </div>
          </div>
        </div>
      </div>
      <div
        class="set-btn"
        @mouseenter="dropdropshow('set')"
        @mouseleave="dropdropdropshow('set')"
      >
        <div style="margin-right: 8px">设置</div>
        <div class="drop-down-icon"></div>
        <div class="set-option-box" v-show="sethover">
          <div class="set-option-item" @click="handleCommand(1)">跳至后台</div>
          <div class="set-option-item" @click="handleCommand(3)">APP下载</div>
          <div class="set-option-item" @click="handleCommand(2)">退出登录</div>
        </div>
      </div>
    </div>

    <el-dialog
        title="APP下载"
        :visible.sync="APPdialogVisible"
        :modal-append-to-body="false"
        width="30%">
    </el-dialog>

  </div>
</template>
<script>
import { getrouters, getrouterslist, saasinfo } from "@/request/api";
import router from "@/router";
import { mapState } from "vuex";
import axios from "axios";

export default {
  name: "redheader",
  data() {
    return {
      userinfo: {
        nickname: "",
      },
      dropshow: false,
      sethover: false,
      menuid: null,
      RouteList: [],
      perxit: [
        {
          name: "跳至后台",
          url: "",
        },
        {
          name: "退出登录",
          url: "",
        },
      ],
      APPdialogVisible:false
    };
  },
  computed: {
    ...mapState(["head"]),
  },
  created() {
    saasinfo().then((res) => {
      localStorage.setItem("userinfo", JSON.stringify(res.data));
      this.userinfo = res.data;
    });
    getrouterslist()
      .then((res) => {
        res.data.map((item, index) => {
          item.isshow = false;
          item.menuIcon = process.env.VUE_APP_BASE_URL + item.menuIcon;
        });
        this.RouteList = res.data;
      })
      .catch((err) => {});
  },
  mounted() {},
  methods: {
    dropdropshow(e) {
      if (e == "set") {
        this.sethover = true;
      } else {
        this.menuid = e;
      }
    },
    dropdropdropshow(e) {
      this.menuid = null;
      this.sethover = false;
    },
    navtopushfun(menuId, url, type, status) {
      getrouters({ fmenu: menuId }).then((res) => {
        localStorage.setItem("routerslist", JSON.stringify(res.data));
        if (res.data.length === 0 || status === 2) {
          this.$message({
            message: "尽情期待",
            type: "warning",
          });
        } else {
          if (type === 2) {
            window.open(url, "_blank");
          } else {
            this.$router.push({
              path: `/${url}`,
              query: { menuId: menuId },
            });
          }
        }
      });
    },
    clicknavgethome(e) {
      router.push({
        path: "/",
      });
    },
    handleCommand(e) {
      switch (e) {
        case 1:
          let token = localStorage.getItem("token");
          let workerid = localStorage.getItem("worker_id");
          let organid = localStorage.getItem("organ_id");
          // window.open(
          //   `http://ht.jczsaas.com/?token=${token}&workerid=${workerid}&organid=${organid}`,
          //   "_blank"
          // );
          // https://zdjczlcs.dltang.cn:18021/login
          // https://ht.jczsaas.com:18021/login
          window.open(
            `https://ht.jczsaas.com:18021/?token=${token}&workerid=${workerid}&organid=${organid}`,
            "_blank"
          );
          break;
        case 2:
          localStorage.clear();
          this.$router.replace({
            path: "/login",
          });
          break;
        case 3:
          this.APPdialogVisible=true
          break;
      }
    },
  },
};
</script>
